import { FILE_UPLOAD_CONFIG, DATE_VALIDATION, PAYMENT_MESSAGES } from './constants';

// Helper function to parse and validate Brazilian date format (DD/MM/YYYY)
const parseBrazilianDate = (dateString) => {
  if (!dateString || typeof dateString !== 'string') {
    return null;
  }

  const parts = dateString.split('/');
  if (parts.length !== 3) {
    return null;
  }

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  // Validate date components
  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return null;
  }

  // Basic range validation
  if (month < 1 || month > 12) {
    return null;
  }

  // Calculate days in month
  const daysInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || day > daysInMonth) {
    return null;
  }

  // Validate year (reasonable range)
  if (year < DATE_VALIDATION.MIN_YEAR || year > DATE_VALIDATION.MAX_YEAR) {
    return null;
  }

  // Create and validate the date
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  // Return ISO format date string
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const validateFile = (file) => {
  if (!file) {
    return { valid: true };
  }

  // Validate file type - must have both valid extension AND valid MIME type
  const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
  if (!FILE_UPLOAD_CONFIG.ALLOWED_EXTENSIONS.includes(fileExtension) || !FILE_UPLOAD_CONFIG.ALLOWED_MIME_TYPES.includes(file.type)) {
    return {
      valid: false,
      error: PAYMENT_MESSAGES.FILE_TYPE_ERROR
    };
  }

  // Validate file size
  if (file.size > FILE_UPLOAD_CONFIG.MAX_SIZE) {
    return {
      valid: false,
      error: PAYMENT_MESSAGES.FILE_SIZE_ERROR
    };
  }

  return { valid: true };
};

export const formatFormData = (formData, payment) => {
  const submitData = {};

  // Add all fields to submitData
  Object.keys(formData).forEach(key => {
    if (formData[key] !== null && formData[key] !== '') {
      if (key === 'date' || key === 'due_date') {
        if (formData[key]) {
          // Handle string dates directly - they should already be in YYYY-MM-DD format
          if (typeof formData[key] === 'string') {
            // Try to parse Brazilian date format if needed
            const parsedDate = parseBrazilianDate(formData[key]);
            if (parsedDate) {
              submitData[key] = parsedDate;
            } else if (formData[key].match(DATE_VALIDATION.BRAZILIAN_DATE_REGEX)) {
              // Already in ISO format (YYYY-MM-DD)
              submitData[key] = formData[key];
            }
            // If date format is invalid, silently skip the field
            // The backend will validate and return appropriate error
          }
        }
      } else if (key === 'file' && formData[key]) {
        submitData[key] = formData[key];
      } else if (key !== 'file') {
        submitData[key] = formData[key];
      }
    }
  });

  // Add sales_order if it exists
  if (payment?.sales_order) {
    submitData.sales_order = payment.sales_order;
  }

  return submitData;
};